<template>
    <div class="container">
        <!--form-->
        <el-form size="mini" :inline="true" label-position="left" :label-width="queryFormLabelWidth" :model="queryForm" ref="queryForm">
            <el-form-item label="开始日期" prop="startDate">
                <el-date-picker
                  v-model="queryForm.startDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="结束日期" prop="endDate">
                <el-date-picker
                  v-model="queryForm.endDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期">
                </el-date-picker>
            </el-form-item>
            <!--<el-form-item label="支付方式" prop="payway">-->
                <!--<el-select v-model="queryForm.payway" placeholder="请选择">-->
                    <!--<el-option label="全部" :value="0"></el-option>-->
                    <!--<el-option label="校园卡" :value="1"></el-option>-->
                    <!--<el-option label="非校园卡" :value="2"></el-option>-->
                <!--</el-select>-->
            <!--</el-form-item>-->
            <el-form-item>
                <el-button type="primary" @click="getTableData">查询</el-button>
                <!--<el-button @click="resetForm('queryForm')">重置</el-button>-->
            </el-form-item>
        </el-form>
        <div class="line"></div>
        <el-row class="pb20">
            <el-button type="primary" size="mini" @click="printPDF">打印</el-button>
        </el-row>

        <!--table-->
        <div class="report" v-loading="loading">
            <div class="header">
                <p>商户分餐汇总结算表</p>
                <p>时间{{this.startDate}}至{{this.endDate}}</p>
            </div>
            <div class="body" v-if="tableData.length > 0">
                <el-row>
                    <el-col :span="4"><div class="td" style="height: 44px;line-height: 44px;">商户名称</div></el-col>
                    <el-col :span="4">
                        <div class="td">早餐</div>
                        <el-row>
                            <el-col :span="10"><div class="td">人次</div></el-col>
                            <el-col :span="14"><div class="td">金额（元）</div></el-col>
                        </el-row>
                    </el-col>
                    <el-col :span="4">
                        <div class="td">午餐</div>
                        <el-row>
                            <el-col :span="10"><div class="td">人次</div></el-col>
                            <el-col :span="14"><div class="td">金额（元）</div></el-col>
                        </el-row>
                    </el-col>
                    <el-col :span="4">
                        <div class="td">晚餐</div>
                        <el-row>
                            <el-col :span="10"><div class="td">人次</div></el-col>
                            <el-col :span="14"><div class="td">金额（元）</div></el-col>
                        </el-row>
                    </el-col>
                    <el-col :span="4">
                        <div class="td">夜宵</div>
                        <el-row>
                            <el-col :span="10"><div class="td">人次</div></el-col>
                            <el-col :span="14"><div class="td">金额（元）</div></el-col>
                        </el-row>
                    </el-col>
                    <el-col :span="4">
                        <div class="td no-br">合计</div>
                        <el-row>
                            <el-col :span="10"><div class="td">人次</div></el-col>
                            <el-col :span="14"><div class="td no-br">金额（元）</div></el-col>
                        </el-row>
                    </el-col>
                </el-row>
                <el-row v-for="(item,index) in tableData" :key="index">
                    <el-col :span="4">
                        <div class="td" v-if="item.type == 1">
                            {{item.schoolName || '学校名称无'}}
                        </div>
                        <div class="td" v-if="item.type == 2" style="background-color: #f3b084">
                            {{item.merchantName || '商户名称无'}}
                        </div>
                        <div class="td" v-if="item.type == 3">
                            {{item.shopName || '店铺名称无'}}
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <el-row>
                            <el-col :span="10"><div class="td">{{item.orderCountBreakfast}}</div></el-col>
                            <el-col :span="14"><div class="td">{{item.orderAmountBreakfast}}</div></el-col>
                        </el-row>
                    </el-col>
                    <el-col :span="4">
                        <el-row>
                            <el-col :span="10"><div class="td">{{item.orderCountLunch}}</div></el-col>
                            <el-col :span="14"><div class="td">{{item.orderAmountLunch}}</div></el-col>
                        </el-row>
                    </el-col>
                    <el-col :span="4">
                        <el-row>
                            <el-col :span="10"><div class="td">{{item.orderCountDinner}}</div></el-col>
                            <el-col :span="14"><div class="td">{{item.orderAmountDinner}}</div></el-col>
                        </el-row>
                    </el-col>
                    <el-col :span="4">
                        <el-row>
                            <el-col :span="10"><div class="td">{{item.orderCountMidnight}}</div></el-col>
                            <el-col :span="14"><div class="td">{{item.orderAmountMidnight}}</div></el-col>
                        </el-row>
                    </el-col>
                    <el-col :span="4">
                        <el-row>
                            <el-col :span="10"><div class="td">{{item.orderCount}}</div></el-col>
                            <el-col :span="14"><div class="td no-br">{{item.orderAmount}}</div></el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
            <div class="footer" v-if="tableData.length > 0">
                <el-row type="flex" justify="space-around">
                    <el-col :span="6">制表人</el-col>
                    <el-col :span="6">审核人</el-col>
                    <el-col :span="6">制表时间</el-col>
                </el-row>
            </div>
            <div class="no-data" v-else>暂无数据～</div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    export default {
        data() {
            return {
                queryFormLabelWidth: '100px',//自定义查询表单label宽度
                queryForm: {//查询表单数据
                    startDate: '',
                    endDate: '',
                    // userType: this.$store.getters.type == 1?2:3,
                    // schoolId: 337,
                    // merchantId: 107,
                    // payway: 0,
                    for_report: true
                },

                tableData: {},
                startDate: '',
                endDate: '',
                loading: false
            }
        },
        created(){
            var day = new Date();
            day.setTime(day.getTime()-7*24*60*60*1000);
            this.queryForm.startDate = day;
            this.queryForm.endDate = new Date();
            if(this.$store.getters.type == 1){
                this.queryForm.userType = 2;
                this.queryForm.schoolId = JSON.parse(localStorage.getItem('accountInfo')).school_id;
            }else{
                this.queryForm.userType = 3;
                // this.queryForm.schoolId = JSON.parse(localStorage.getItem('accountInfo')).school_id;
                this.queryForm.merchantId = JSON.parse(localStorage.getItem('accountInfo')).commercial_id;
            }
            this.getTableData();
        },
        methods: {
            getTableData() {
                // this.loading = true;
                this.tableData = [];
                let params = {...this.queryForm};
                params.startDate = this.startDate = moment(params.startDate).format('YYYY-MM-DD');
                params.endDate = this.endDate = moment(params.endDate).format('YYYY-MM-DD');
                this.$apiJava.get(this.$apiUrl.reportPartnerDinning,params,(res)=>{
                    this.tableData = res.data;
                    this.loading = false;
                },(res)=>{
                    this.$message.warning(res.message);
                    this.tableData = {};
                    this.loading = false;
                },'oc')
            },
            printPDF() {
                let hostStr = window.location.host;
                let host = hostStr.replace('e','oc');
                let url;
                if(this.queryForm.schoolId){
                    url = location.protocol +'//'+ host + '/' + this.$apiUrl.reportPartnerExportPDF + '?userType=' + this.queryForm.userType + '&schoolId=' + this.queryForm.schoolId + '&startDate=' + moment(this.queryForm.startDate).format('YYYY-MM-DD') + '&endDate=' + moment(this.queryForm.endDate).format('YYYY-MM-DD') + '&export=2';
                }else{
                    url = location.protocol +'//'+ host + '/' + this.$apiUrl.reportPartnerExportPDF + '?userType=' + this.queryForm.userType + '&merchantId=' + this.queryForm.merchantId + '&startDate=' + moment(this.queryForm.startDate).format('YYYY-MM-DD') + '&endDate=' + moment(this.queryForm.endDate).format('YYYY-MM-DD') + '&export=2';
                }
                window.open(url);
            }
        }
    }
</script>
<style lang="scss"  scoped>
    .report{
        width: 90%;
        /*min-height: 500px;*/
        border: 1px solid #ddd;
        text-align: center;
        font-size: 13px;
    }
    .report .header{
        font-size: 16px;
        padding: 20px 0;
    }
    .report .body{
        border-bottom: 1px solid #ddd;
    }
    .report .body .td{
        border: 1px solid #ddd;
        border-left: none;
        border-bottom: none;
        padding: 2px 0;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
    .report .body .td.no-br{
        border-right: none;
    }
    .report .body .td.no-bt{
        border-top: none;
    }
    .report .body .td.bg{
        background-color: #f3b084;
    }
    .report .footer{
        padding: 20px 0;
        text-align: left;
    }
    .no-data{
        padding: 20px 0;
    }
</style>


// WEBPACK FOOTER //
// dinner.vue?09d03562